<script lang="ts">
  import { t } from '$lib/i18n/index.svelte';
  import { defang } from '$lib/protocol/link-guard';
  import type { NotificationElement } from '$lib/protocol/types';

  let { element, ctx }: { element: NotificationElement; ctx?: { mutedCategories: ReadonlySet<string> } } =
    $props();

  const icons: Record<string, string> = {
    order_status: '📦',
    reminder: '⏰',
    outage: '⚠️',
    other: 'ℹ️',
  };

  // Muting is local only — the sender never learns about it. A muted category
  // collapses quietly instead of vanishing: history stays complete.
  const muted = $derived(ctx?.mutedCategories.has(element.category) ?? false);
</script>

{#if muted}
  <p class="muted">{icons[element.category]} {t('contact.muted')}</p>
{:else}
  <p class="notification">
    <span aria-hidden="true">{icons[element.category]}</span>
    {defang(element.text)}
  </p>
{/if}

<style>
  .notification {
    margin: 0;
    white-space: pre-wrap;
  }
  .muted {
    margin: 0;
    font-size: 13px;
    color: var(--ink-soft);
    font-style: italic;
  }
</style>
